import { ApolloClient } from '@apollo/client';

import { RetrieveAllSubmissions, RetrieveSubmissions, Submission } from '../customGraphqlTypes';
import { RetrieveAllSubmissionsGQL, RetrieveSubmissionsGQL } from '../queries/SubmissionQueries';

export const getSubmissionByExternalId = async (id: string, client: ApolloClient<any>, structureType?: string) => {
  const result = await client.query<RetrieveSubmissions>({
    query: RetrieveSubmissionsGQL,
    variables: { externalId: id },
  });

  const data = result?.data?.submissions;

  let submission: Submission = null;
  const structure = structureType
    ? result?.data?.submissions?.find((value) => value.type === structureType)
    : result?.data?.submissions?.[0];

  if (data && structure) {
    submission = {
      structure: structure,
      externalId: id,
    };
  }

  return submission;
};

export const getSubmissionsByExternalId = async (id: string, structureTypes: string[], client: ApolloClient<any>) => {
  const result = await client.query<RetrieveSubmissions>({
    query: RetrieveSubmissionsGQL,
    variables: { externalId: id },
  });

  let submissions: Submission[] = [];
  structureTypes.forEach((structureType) => {
    submissions = [
      ...submissions,
      ...(result?.data?.submissions
        ?.filter((value) => value.type === structureType)
        ?.map((structure) => {
          return {
            structure,
            externalId: id,
          };
        }) || []),
    ];
  });
  return submissions;
};

export const getSubmissions = async (client: ApolloClient<any>) => {
  const result = await client.query<RetrieveAllSubmissions>({
    query: RetrieveAllSubmissionsGQL,
  });

  const data = result?.data?.findAllByUserId;

  return data;
};
